import { getDownloadSpeed } from 'functions/deviceFeatures';
import { useEffect, useState } from 'react';

export interface DeviceFeatures {
  downloadSpeed?: number;
  cameraResolution?: string;
}

export function useDeviceFeatures(
  mediaStreamTrack?: MediaStreamTrack
): DeviceFeatures | undefined {
  const [deviceFeatures, setDeviceFeatures] = useState<
    DeviceFeatures | undefined
  >(undefined);

  useEffect(() => {
    if (deviceFeatures || !mediaStreamTrack) return;
    (async () => {
      const cameraResolution = `${mediaStreamTrack?.getSettings().width}x${
        mediaStreamTrack?.getSettings().height
      }`;
      const downloadSpeed = await getDownloadSpeed();
      setDeviceFeatures({ cameraResolution, downloadSpeed });
    })();
  }, [mediaStreamTrack]);

  return deviceFeatures;
}
